import React from "react"
import { Link } from "gatsby"

import TwitterLogo from "../images/Twitter.svg"
import LinkedInLogo from "../images/Group 87.svg"

import PhoneSVG from "../images/phone.svg"
import EmailSVG from "../images/email.svg"

import AWSImage from "../images/aws.png"
import CyberEssentialsImage from "../images/cyberessentialsimage.png"
import GCloudImage from "../images/gcloud.png"
import FlexaSeal from "../images/top-50-seal-pink.png"

import "./footer.scss"

import LogoSVG from "../images/MissionLabs_Logo_Horizontal_Strapline.svg"

const Footer = () => (
  <footer className="footer centre">
    <div className="footer-cols">
      <div>
        <img className="logo" src={LogoSVG} alt="" />
        <p>
          We power the future of business communications through cutting-edge
          technology.
        </p>
        <ul>
          <li>
            <img className="contact-icon" src={PhoneSVG} alt="" />
            +44 (0)3330 50 50 50
          </li>
          <li>
            <div className="footer__socials">
              <a
                href="https://www.linkedin.com/company/missionlabs"
                target="_blank"
                rel="noreferrer"
              >
                <img src={LinkedInLogo} alt="" />
              </a>
              <a
                href="https://twitter.com/MissionLabsHQ"
                target="_blank"
                rel="noreferrer"
              >
                <img src={TwitterLogo} alt="" />
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-hidden">
        <LinkList
          title={"Solutions."}
          items={[
            {
              name: "Cloud Communications.",
              link: "/solutions/cloud-communication",
            },
            { name: "Contact Centre", link: "/solutions/contact-centre" },
            {
              name: "Contact Automation.",
              link: "/solutions/contact-automation",
            },
            { name: "Agent Efficiency.", link: "/solutions/agent-efficiency" },
            { name: "Amazon Connect", link: "/solutions/amazon-connect" },
            {
              name: "Quality Management.",
              link: "/solutions/quality-management",
            },
            { name: "Payments & PCI.", link: "/solutions/payments-pci" },
            { name: "Integrations.", link: "/integrations" },
            { name: "Technology.", link: "/technology" },
          ]}
        />
      </div>
      <div className="mobile-hidden">
        <LinkList
          title={"Products."}
          items={[
            { name: "SmartAgent.", link: "/products" },
            { name: "CircleLoop.", link: "/products" },
            { name: "SmartPCI.", link: "/products" },
          ]}
        />
      </div>
      <div>
        <div className="mobile-hidden">
          <LinkList
            title={"Company."}
            items={[
              { name: "Our Clients.", link: "/clients" },
              { name: "About.", link: "/about" },
              { name: "Blog.", link: "/blog" },
              { name: "Careers.", link: "/careers" },
            ]}
          />
        </div>
        <div className="creditals container">
          <div>
            <img src={AWSImage} alt="AWSImage" />
          </div>
          <div>
            <a
              href="https://flexa.careers/companies/missionlabs"
              target="_blank"
            >
              <img src={FlexaSeal} alt="FlexaSeal" />
            </a>
          </div>
          <div>
            <img src={CyberEssentialsImage} alt="CyberEssentialsImage" />
          </div>
          <div>
            <img src={GCloudImage} alt="GCloudImage" />
          </div>
        </div>
      </div>
    </div>
    <div className="terms">
      © Mission Labs 2020.
      <a href="/terms">Terms</a> | <a href="/terms">Privacy</a> |{" "}
      <a href="https://www.gammacommunicationsplc.com/modern-slavery-statement/" target="_blank">Modern Slavery</a>
    </div>
  </footer>
)

export default Footer

const LinkList = ({ title, items }) => {
  return (
    <>
      <div className="bold">{title}</div>
      <ul>
        {items.map(({ name, link }, idx) => (
          <li key={idx}>{link ? <Link to={link}>{name}</Link> : name}</li>
        ))}
      </ul>
    </>
  )
}
